export default __webpack_public_path__ + "static/media/card-profile2.cdba958e.jpg";